<template>
  <div class="landing-page">
    <content-header @tab-change="(e) => changePanel(e)"/>
    <div class="content-section">
      <div class="content-left">
        <login-page v-if="!isLoggedIn"/>
        <user-panel v-else-if="user && isLoggedIn" @action="(e) => panel = e" @logout="logout"/>
        <ranking-page />
      </div>
      <div class="content-right">
        <home-panel v-if="panel === 'home'"/>
        <news-panel v-else-if="panel === 'news'"/>
        <download-link-page v-else-if="panel === 'download'"/>
        <ranking-panel-page v-else-if="panel === 'ranking'"/>
        <server-info-page v-else-if="panel === 'server-info'"/>
        <item-shop-page v-else-if="panel === 'item-shop'" />
        <user-panel-page v-else-if="user && isLoggedIn" :userPanel="panel" />
      </div>
    </div>
  </div>
</template>

<style>
</style>

<script>
import LoginPage from '@/components/login/LoginPage.vue'
import RankingPage from '@/components/ranking/RankingPage.vue';
import HomePanel from '../HomePanel/HomePanel.vue';
import NewsPanel from '../NewsPanel/NewsPanel.vue'
import ContentHeader from '@/components/ContentHeader.vue';
import UserPanel from '@/components/user-panel/UserPanel.vue'
import UserPanelPage from '../UserPanel/UserPanel.vue'
import DownloadLinkPage from '../DownloadPanel/DownloadLinkPage'
import ServerInfoPage from '../ServerInfoPanel/ServerInfoPage'
import RankingPanelPage from '../RankingPanel/RankingPage.vue'
import ItemShopPage from '@/components/user-panel/contents/item-shop/ItemShopPage.vue';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'LandingPage',
  components: {
    ContentHeader,
    LoginPage,
    RankingPage,
    HomePanel,
    NewsPanel,
    UserPanel,
    UserPanelPage,
    DownloadLinkPage,
    ServerInfoPage,
    RankingPanelPage,
    ItemShopPage
  },
  computed: {
    ...mapGetters({
      user: 'user/getUser',
      isLoggedIn: 'user/isLoggedIn'
    })
  },
  data () {
    return {
      panel: 'home'
    }
  },
  watch: {
    '$route' (val) {
      if (val.name === 'Dashboard') this.panel = 'home'
    }
  },
  async mounted () {
    this.panel = 'home'

    if (localStorage.getItem('checked') === 'not') {
      const param = {
        session_id: localStorage.getItem('session_id'),
        status: localStorage.getItem('topup'),
        ref: localStorage.getItem('ref')
      }
      this.$q.loading.hide()
      this.$q.loading.show()

      await this.requestCheckTopupStatus(param)
        .then(response => {
          this.$q.notify({
            position: 'top-right',
            message: response.data.message,
            type: 'positive'
          })
        })
        .catch(error => {
          this.$q.notify({
            position: 'top-right',
            message: error.response.data.message,
            type: 'negative'
          })
        })
      
      localStorage.removeItem('checked')
      localStorage.removeItem('session_id')
      localStorage.removeItem('topup')
      localStorage.removeItem('ref')

      this.$router.push('/')
      this.$q.loading.hide()
    }
  },
  methods: {
    ...mapActions({
      userLogout: 'user/logout',
      requestCheckTopupStatus: 'user/requestCheckTopupStatus'
    }),
    changePanel(panel) {
      this.panel = panel
      console.log(panel)
    },
    async logout () {
      this.$q.loading.show();

      await this.userLogout()
        .then(()=> {
          this.panel = 'home'
          this.$router.push('/')
          this.$q.loading.hide();
        })
        .catch(err => {
          this.$q.notify({
            position: 'top-right',
            message: err,
            type: 'negative'
          })

          this.$q.loading.hide();
        })
    }
  }
}
</script>

<style lang="scss">
.landing-page {
  .content-section {
    display: grid;
    grid-template-columns: 360px 2.35fr;
    gap: 24px;

    .content-left {
      margin-top: 60px;
      max-width: 360px;
    }

    .content-right {
      margin-top: 60px;
      max-width: 863px;
    }
  }
}
</style>
